<template>
  <a :href="route" style="color: inherit;" class="adminCard">
    <div class="card sub-card text-white">
      <div class="card-body row px-4 px-md-2 py-3">
        <div class="col-md-3 text-center">
          <i class="fas fa-sign-in-alt fa-4x d-none d-xl-block d-xxl-block mt-2 mt-xl-0"></i>
          <i class="fas fa-sign-in-alt fa-3x d-none d-md-block d-lg-block d-xl-none mt-2"></i>
          <i
            class="fas fa-sign-in-alt fa-3x d-block d-md-none position-absolute mt-2"
            style="right:16px;"
          ></i>
        </div>
        <div class="col-5">
          <h3 v-if="!sortingQueueCountLoading">
            <strong>{{ sortingQueueCount }}</strong>
          </h3>
          <h3 v-else>
            <i class="fa fa-spinner fa-pulse fa-fw"></i>
          </h3>
          <div class="d-xxl-none">Subs</div>
          <div class="d-none d-xxl-block">Submissions</div>
        </div>
        <div class="col-4">
          <h3 v-if="!subCountLoading">
            <strong>{{ submissionCount }}</strong>
          </h3>
          <h3 v-else>
            <i class="fa fa-spinner fa-pulse fa-fw"></i>
          </h3>
          <div>{{ timescale }}</div>
        </div>
      </div>
    </div>
  </a>
</template>

<script>
export default {
  name: "SortingCard",

  props: {
    route: {
      required: true,
      type: String
    },
    timescale: {
      type: String,
      default: "Today"
    }
  },

  data() {
    return {
      sortingQueueCountLoading: true,
      subCountLoading: true,
      sortingQueueCount: 0,
      submissionCount: 0
    };
  },

  created() {
    this.loadSortingQueue();
    this.loadSubmissionCount();
  },

  methods: {
    loadSortingQueue() {
      this.sortingQueueCountLoading = true;
      var self = this;
      axios
        .get("api/queues/sorting/count")
        .then(function(response) {
          self.sortingQueueCountLoading = false;
          // convert to an array (so we can easily get the length)
          self.sortingQueueCount = response.data;
        })
        .catch(function(error) {
          console.log(error);
        });
    },

    loadSubmissionCount() {
      this.subCountLoading = true;
      var self = this;
      axios
        .get("api/stats/submissions/count", {
          params: {
            timescale: this.timescale
          }
        })
        .then(function(response) {
          self.subCountLoading = false;
          // convert to an array (so we can easily get the length)
          self.submissionCount = response.data;
        })
        .catch(function(error) {
          console.log(error);
        });
    }
  }
};
</script>